import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d608874"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "g-container my-2.5 hidden sm:block" }
const _hoisted_2 = { class: "bg-[#FAFAFA]" }
const _hoisted_3 = { class: "w-full mx-auto text-xs text-gary-text-color tracking-[.1em] sm:text-sm flex flex-col gap-6 sm:px-[20%] p-1.5 sm:py-[50px] pt-[50px]" }
const _hoisted_4 = { class: "text-gary-text-color font-bold text-[18px] sm:text-[24px] text-center leading-[1.25] px-[30px]" }
const _hoisted_5 = { class: "flex items-center justify-center w-[80%] m-auto mt-[-21px]" }
const _hoisted_6 = { class: "mt-[-2px]" }
const _hoisted_7 = { class: "w-full flex sm:flex-row flex-col gap-[30px] px-[30px] justify-center" }
const _hoisted_8 = { class: "w-auto" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gary-text-color font-medium text-sm text-left" }, " 活動說明 ", -1))
const _hoisted_10 = { class: "text-left text-xs leading-[17px] list-disc list-none pl-0 content-list" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "w-auto sm:ml-[20px]" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gary-text-color font-medium text-sm text-left" }, " 注意事項 ", -1))
const _hoisted_14 = { class: "text-left text-xs leading-[17px] list-disc list-none pl-0 warningDesc-list" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "g-container flex flex-col sm:mt-10 sm:p-0" }
const _hoisted_17 = { class: "g-container flex flex-col pt-0 sm:p-0" }
const _hoisted_18 = { class: "mx-[16px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Banner = _resolveComponent("Banner")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Title = _resolveComponent("Title")!
  const _component_UnderLine = _resolveComponent("UnderLine")!
  const _component_ProductClassItemList = _resolveComponent("ProductClassItemList")!
  const _component_ProductItemList = _resolveComponent("ProductItemList")!
  const _directive_clickOutSide = _resolveDirective("clickOutSide")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb, {
        breadcrumbList: [{ path: '/', title: _ctx.cmdyClassItem.Name || '' }]
      }, null, 8, ["breadcrumbList"])
    ]),
    _createVNode(_component_Banner, {
      image: _ctx.promotionData.BannerImage !== undefined ? _ctx.promotionData.BannerImage : ''
    }, null, 8, ["image"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.promotionData.Name), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Icon, { "icon-name": "clock" }),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.promotionData.EffectiveDateStart) + " - " + _toDisplayString(_ctx.promotionData.EffectiveDateEnd), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotionData.Content, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  innerHTML: item
                }, null, 8, _hoisted_11))
              }), 128))
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotionData.WarningDesc, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  innerHTML: item
                }, null, 8, _hoisted_15))
              }), 128))
            ])
          ], 512), [
            [_vShow, _ctx.promotionData.WarningDesc?.length > 0]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_Title, {
        class: "g-title-type2 mt-[40px] mb-[40px] sm:my-[60px]",
        title: '期間限定'
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["w-full", { 'g-container': !_ctx.isMobile().phone }])
      }, null, 2),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_UnderLine)
        ]),
        _createVNode(_component_ProductClassItemList, {
          onGetCmdyClassList: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getPromotionCmdyListById(true)))
        }),
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          (!_ctx.isMobile().phone)
            ? (_openBlock(), _createBlock(_component_ProductItemList, {
                key: 0,
                ref: "RefProductItemList",
                getCmdyClassList: _ctx.clickProductItemList,
                "onUpdate:getCmdyClassList": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.clickProductItemList) = $event)),
                cmdyThemeList: _ctx.cmdyThemeList,
                "onUpdate:cmdyThemeList": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cmdyThemeList) = $event)),
                selectThemeList: _ctx.selectThemeList,
                "onUpdate:selectThemeList": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectThemeList) = $event)),
                isGoProductDetail: true,
                onClickProductItem: _ctx.clickProductItem,
                class: "hidden sm:block mt-[36px] sm:mt-[30px]"
              }, null, 8, ["getCmdyClassList", "cmdyThemeList", "selectThemeList", "onClickProductItem"]))
            : _createCommentVNode("", true),
          (_ctx.isMobile().phone)
            ? (_openBlock(), _createBlock(_component_ProductItemList, {
                key: 1,
                class: "sm:hidden mt-[10px] sm:mt-[30px]",
                ref: "RefProductItemListForMobile",
                getCmdyClassList: _ctx.clickProductItemList,
                "onUpdate:getCmdyClassList": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.clickProductItemList) = $event)),
                cmdyThemeList: _ctx.cmdyThemeList,
                "onUpdate:cmdyThemeList": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cmdyThemeList) = $event)),
                selectThemeList: _ctx.selectThemeList,
                "onUpdate:selectThemeList": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectThemeList) = $event)),
                isGoProductDetail: true,
                onClickProductItem: _ctx.clickProductItem,
                row: 2,
                isMobile: true
              }, null, 8, ["getCmdyClassList", "cmdyThemeList", "selectThemeList", "onClickProductItem"]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_clickOutSide, _ctx.closeRecItem]
        ])
      ])
    ])
  ]))
}